import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import DashboardContainer from '../components/dashboard/DashboardContainer';
import LoadingScreen from '../components/navigation/LoadingScreen';
import { canSeeUsersPage, isLoggedIn, } from '../stores/auth/selectors';
import { isLoading } from '../stores/navigation/selectors';
import { RootState } from '../stores/store';

interface Props extends RouteComponentProps, LocalizeContextProps {
    isLoading: boolean;
    isLoggedIn: boolean;
    canSeeUsersPage: boolean;
}

class DefaultRedirect extends React.Component<Props> {
    public render() {
        if (this.props.isLoading) {
            return <LoadingScreen text={this.props.translate('loading.redirecting') as string} />;
        } else if (!this.props.isLoggedIn) {
            return (
                <Redirect
                    to={{
                        pathname: '/login', state: {
                            // This flag is set when the user can be redirected back after logging in
                            auth: this.props.location.pathname !== '/logout',
                            from: this.props.location,
                        }
                    }}
                />
            );
        } else {
            // Redirect to page previous to login
            if (this.props.location.pathname === '/login' && this.props.location.state &&
                // tslint:disable-next-line: no-any
                (this.props.location.state as any).auth) {
                return (
                    <Redirect
                        to={{
                            pathname: this.props.location.pathname, // test this change 
                            state: { from: this.props.location }
                        }}
                    />
                );
            } else {
                return (
                    <Redirect
                        to={{
                            pathname: '/select-app',
                            state: { from: this.props.location }
                        }}
                    />
                );
            }
            return (
                <DashboardContainer>
                    <LoadingScreen text="Logged in" error={true} />
                </DashboardContainer>
            );
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    canSeeUsersPage: canSeeUsersPage(state),
    isLoading: isLoading(state),
    isLoggedIn: isLoggedIn(state),
});

export default connect(mapStateToProps)(withLocalize(withRouter(DefaultRedirect)));